import { BaseContext } from '../../../../../utils/basecontext';
import { ForgotPasswordDto, ForgotPasswordDtoImpl } from '../../../../../core/dto/forgotpassword/forgotpassworddto';
import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { LoginProcessorFactory } from '../../../../../core/processorfactory/loginprocessorfactory';
import { ForgotPasswordResponse } from '../../../../../core/api/forgotpassword/forgotpasswordresponse';
import { ForgotPasswordRequestImpl } from '../../../../../core/api/forgotpassword/forgotpasswordrequest';
import { RsaService } from 'src/com/sixdee/crbtportal/utils/rsaservice';
import { SecurityTokenDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/securitytoken/securitytokendto';
import { SecurityTokenResponse } from 'src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenresponse';
import { SecurityTokenRequestImpl } from 'src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenrequest';
import { SendOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/sendotp/sendotpresponse';
import { SendOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/sendotp/sendotprequest';
import { SendOTPDto, SendOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';

export interface ForgotPasswordOTPMessageAPIModel extends APIModel
{
    resetPassword(forgotPasswordDto: ForgotPasswordDto): void;
    resendOtp(msisdn: string): void;
}

export class ForgotPasswordOTPMessageAPIModelImpl extends APIModelImpl implements ForgotPasswordOTPMessageAPIModel
{
    private loginProcessorFactory: LoginProcessorFactory;

    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
        
        this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
    }

    resendOtp(msisdn: string): void 
    {
        let sendotpdto = new SendOTPDtoImpl();
        sendotpdto.setMsisdn(msisdn);

        this.resendOtpFunc(sendotpdto);
    }

    resetPassword(forgotPasswordDto: ForgotPasswordDto): void 
    {   
        let securityTokenDto : SecurityTokenDtoImpl = new SecurityTokenDtoImpl();
        this.loginProcessorFactory.getSecurityToken()
        .success((securityTokenResponse : SecurityTokenResponse)=>
        {
            let encryptedPassword = RsaService.getInstance(this.getContext().getProperty())
                .encryptWithNodeRSA(forgotPasswordDto.getPassword() + securityTokenResponse.getSecurityCounter());
          
                (forgotPasswordDto as ForgotPasswordDtoImpl).setSecurityToken(securityTokenResponse.getSecurityCounter());
                (forgotPasswordDto as ForgotPasswordDtoImpl).setEncryptedPassword(encryptedPassword);
                
                this.loginProcessorFactory.resetPassword()
                    .success((forgotPasswordResponse : ForgotPasswordResponse)=>
                    {
                       this.getAPIModelHandler().onSuccess(forgotPasswordResponse.getAPIFeature(), 
                       forgotPasswordResponse.getDescription(), forgotPasswordResponse);
                    })
                   .failure((forgotPasswordResponse : ForgotPasswordResponse)=>
                   {
                      this.getAPIModelHandler().onFailure(forgotPasswordResponse.getAPIFeature(), 
                      forgotPasswordResponse.getDescription(), forgotPasswordResponse);
                   }).execute(new ForgotPasswordRequestImpl(forgotPasswordDto));
            })
            .failure((securityTokenResponse : SecurityTokenResponse)=>
            {
                this.getAPIModelHandler().onFailure(securityTokenResponse.getAPIFeature(), 
                securityTokenResponse.getDescription(), securityTokenResponse);
            })
            .execute(new SecurityTokenRequestImpl(securityTokenDto));
    } 

    private resendOtpFunc(createAccountSendOtpDto: SendOTPDto): void 
    {
        this.loginProcessorFactory.sendOTP()
                .success((generateOTPResponse : SendOTPResponse)=>
                {
                    this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                    generateOTPResponse.getDescription(), generateOTPResponse.getSendOTPDto());
                })
                .failure((generateOTPResponse : SendOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse);

                }).execute(new SendOTPRequestImpl(createAccountSendOtpDto));
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/forgotpasswordotp/forgotpasswordotpmessage/forgotpasswordotpmessageapimodel.tsx